import { createSlice, PayloadAction } from '@reduxjs/toolkit';


interface ChangePasswordDialogState {
  dialogOpen: boolean;
  lastPasswordChange: string | null;
}

const initialState: ChangePasswordDialogState = {
  dialogOpen: false,
  lastPasswordChange: null
};

const slice = createSlice({
  name: 'ui/change-password',
  initialState: initialState,
  reducers: {
    openDialog: (state) => {
      state.dialogOpen = true;
    },
    closeDialog: (state) => {
      state.dialogOpen = false;
    },
    updatePasswordDate: (state, action: PayloadAction<string>) => {
      state.lastPasswordChange = action.payload;
    }
  }
})

export const { reducer: changePasswordReducer, actions: changePasswordActions } = slice;


